import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserState } from '../state/current-user.state';

export const portalDirectorsGuard: CanActivateFn = () => {
  const currentUserState = inject(CurrentUserState);
  const router = inject(Router);

  if (currentUserState.user()?.canAccessDirectors) {
    return true;
  }

  router.navigate(['/portal']);
  return false;
};
